import { ReactNode, useState } from 'react';

import Box from '@mui/material/Box';

import AppBar from './AppBar';
import InAppBanner from './InAppBanner';
import NavigationMenu from './NavigationMenu';
import AccessDenied from '../AccessDenied';
import { useUserStateContext } from '../UserStateProvider';

type Props = {
  children: ReactNode;
  title: string;
  renderSummaryData?: () => ReactNode;
  requiredPermissions?: string[];
};

const AppPage = ({ children, title, renderSummaryData, requiredPermissions }: Props) => {
  const [navigationAnchorEl, setNavigationAnchorEl] = useState<HTMLElement | null>(null);
  const { hasRole, isLoading } = useUserStateContext();

  if (!hasRole || isLoading) {
    return <></>;
  }

  if (requiredPermissions && !hasRole(requiredPermissions)) {
    return <AccessDenied />;
  }

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <InAppBanner />
        <NavigationMenu anchorEl={navigationAnchorEl} onClose={() => setNavigationAnchorEl(null)} />
        <AppBar
          title={title}
          navigationAnchorEl={navigationAnchorEl}
          setNavigationAnchorEl={setNavigationAnchorEl}
          renderSummaryData={renderSummaryData}
        />

        <Box
          component="main"
          sx={(theme) => ({
            flex: 1,
            transition: theme.transitions.create(['margin', 'width'], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
          })}
        >
          {children}
        </Box>
      </Box>
    </>
  );
};

export default AppPage;
